<template>
  <div>
    <div>

      <v-data-table :headers="headers" :items="queue" :loading="loading" :pagination.sync="pagination">
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-start">{{ props.item.id }}</td>
            <td class="text-xs-start">{{ `${props.item.username}` }}</td>
            <td class="text-xs-start">{{ `${props.item.fullname}` }}</td>
            <td class="text-xs-start">{{ `${props.item.order}` }}</td>
            <td>
              <v-icon @click="openDialog(props.item.id)">edit</v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <div>
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">
              {{ $t("planningPage.enterNewPosition") }}
            </span>
          </v-card-title>
          <v-card-text>
            <input name="comments" type="text" v-model="newPosition" autocomplete="off" class="reservation-position"
              :placeholder="$t('planningPage.enterNewPositionPlaceholder')" />
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" flat  @click="closeDialog">{{ $t("planningPage.close") }}</v-btn>
            <v-btn color="primary" :loading="loading" flat @click="updatePosition">{{ $t("planningPage.submit") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<style lang="scss">
.reservation-position {
  width: 100%;
  max-width: 400px;
  padding: 16px 15px;
  font-size: 14px;
  border-radius: 10px;
  border: 1px solid #c1c5d8;
  background-color: #f7f8fa;
  color: #202731;
}
</style>

<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";

export default {
  name: "ReservationQueue",
  title() {
    return this.$t("planningPage.reservationQueueTitle");
  },
  components: { DataTable },
  data() {
    return {
      queue: [],
      newPosition: null,
      selectedCaptain: null,
      loading: true,
      dialog: false,
      pagination: {
        rowsPerPage: 25
      },
    };
  },

  computed: {
    headers() {
      return [
        { text: this.$t("planningPage.captainIdCol"), value: "id" },
        { text: this.$t("planningPage.captainUsernameCol"), value: "username" },
        { text: this.$t("planningPage.captainNameCol"), value: "fullname" },
        { text: this.$t("planningPage.orderCol"), value: "order" },
      ];
    },
  },
  methods: {
    openDialog(captain_id) {
      this.selectedCaptain = captain_id;
      this.dialog = true;
    },
    closeDialog(captain_id) {
      this.newPosition = null;
      this.dialog = false;
    },
    updatePosition() {
      this.loading = true;
      this.axios.post(this.api.ACTIONS.RESERVATION_QUEUE, { 'captain_id': this.selectedCaptain, 'position': this.newPosition })
        .then(
          ({ data })  => {
            this.queue = data.data;
            this.queue.forEach((item) => {
              item.order = this.queue.filter(
                (a) => a.order <= item.order
              ).length;
            });
          }
        ).catch((err) => {
          console.log(err.message);
        }
        ).finally(
          () => {
            this.loading = false;
            this.selectedCaptain = null;
            this.newPosition = null;
            this.dialog = false;
          }
        )
    }
  },
  mounted() {
    this.axios.get(this.api.ACTIONS.RESERVATION_QUEUE).then(({ data }) => {
      this.queue = data.data;
      this.queue.forEach((item) => {
        item.order = this.queue.filter(
          (a) => a.order <= item.order
        ).length;
      });
    }).catch((err) => {
      console.log(err.message);
    }).finally(
      () => this.loading = false
    );
  },
};
</script>
